var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPic8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.14 80.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5c1e7;}.cls-2{fill:#ffed4a;}.cls-3{fill:none;stroke:#343a40;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.77,40.87a39.66,39.66,0,0,1-.53,6.49A23.3,23.3,0,0,0,49.76,79.73a38.85,38.85,0,0,1-5.21.35c-21.66,0-40.76-18.31-40.76-40a34.78,34.78,0,0,1,3.5-15,23.28,23.28,0,0,0,21.4,12.08A23.31,23.31,0,0,0,46.46,0h.39C68.51,0,83.77,19.21,83.77,40.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 67.7,
    cy: 63.5,
    rx: 7.96,
    ry: 7.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 27.56,
    cy: 14.35,
    r: 10.04,
    transform: "translate(-2.07 23.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1,75.34,37.45,46.25a167.28,167.28,0,0,1,15.1-10.74C62.68,29.11,80.4,17.6,88.14,10.57"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic8);
export default __webpack_public_path__ + "static/media/Pic8.796d2ee1d88a7c06cf2b6ff7a98c8082.svg";
export { ForwardRef as ReactComponent };